export default class AggIntegrations {
    constructor(api) {
        this.api = api;
        this.AggIntegrationClass = null;
    }

    async init(instance) {
        if (!this.AggIntegrationsClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
               await this.api.util.loadJS(instance.data.cdn.js);
               // await this.api.util.loadJS(["http://localhost:8081/widget_aggIntegrations.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.aggIntegrations &&
                this.api.settings.widgetsUrl.aggIntegrations.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.aggIntegrations.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
               await this.api.util.loadCSS(instance.data.cdn.css);
               //  await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/aggIntegration/css/aggIntegrations.css'])
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.aggIntegrations &&
                this.api.settings.widgetsUrl.aggIntegrations.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.aggIntegrations.css]);
            }
        }
        
        this.AggIntegrationsClass = new window.Widget_aggIntegrations.default(this.api, instance.instance);
    }
}